export default __webpack_public_path__ + "static/media/ticket-bg.71a78957.svg";